import React, { useRef, useEffect, useContext, useState } from "react";
import { useRouter } from "next/router";
import BusinessMenuItem from "../ui/business-menu-item";
import BusinessContext from "../../contexts/business-context";
import { handlelogOut } from "../../lib/auth";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CardBox from "../ui/card-box";

const BusinessMenuItems = ({ open, setIsOpen }) => {
  const router = useRouter();
  const businessCtx = useContext(BusinessContext);
  const [businessList, setBusinessList] = useState(businessCtx.businessList);
  const businessDropdownRef = useRef();
  const business = businessCtx.activeBusiness


  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (
        businessDropdownRef.current &&
        !businessDropdownRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, setIsOpen]);

  if (!open) return null;


  return (
    <CardBox
      additionalclasses="bg-white-50 dark:bg-grey-600 fixed left-[3em] md:left-[11em] lg:left-[15rem] bottom-[1.75em] lg:bottom-3 z-50 !p-0 !py-0 custom-shadow w-[300px]"
      ref={businessDropdownRef}
    >
      <div className="max-h-[400px] overflow-y-auto scrollbar-none">
        {businessList?.map((business, index) => (
          <div
            key={business.uuid}
            className="py-2 px-[4px]"
          >
            <BusinessMenuItem
              id={business.uuid}
              businessName={business.name}
              teamCount={10}
            />
          </div>
        ))}
      </div>
      <div className="grid gap-.5 items-start content-start border-t-[1px] custom-border-grey-50 py-3">
        {!business.is_pseudonymous &&
          <span className="poppins-regular custom-text-grey-800  text-[12px] px-6 py-1 cursor-pointer tracking-[0.5px]"
            onClick={() => router.push("/businesses/new")}>
            Add another business
          </span>
        }
        <span
          onClick={()=> handlelogOut(router)}
          className="poppins-regular custom-text-grey-800  text-[12px] tracking-[0.5px] px-6 py-1 cursor-pointer"
        >
          Log out
        </span>
      </div>
    </CardBox>
  );
};

export default BusinessMenuItems;
